import { EstimateInfoTrigger } from '@liveauctioneers/hammer-ui-liveauctioneers/estimateInfoTrigger';
import { ComponentProps } from 'react';

import { FormattedCurrency } from '@/components/Formatted/FormattedCurrency';

type AmountWithInfoProps = {
    currency: string;
    id: string;
    onMobileClick: ComponentProps<typeof EstimateInfoTrigger>['onMobileClick'];
    spaceAmountFromParent: boolean;
    value: number;
};

/** Keeps the icon with the amount so a tight line wraps before the pair, not under the icon alone. */
export const AmountWithInfo = ({ currency, id, onMobileClick, spaceAmountFromParent, value }: AmountWithInfoProps) => (
    <span className={spaceAmountFromParent ? 'whitespace-nowrap [&>div]:mx-2xs' : 'whitespace-nowrap'}>
        <FormattedCurrency
            noFraction
            sourceCurrency={currency}
            value={value}
        />
        <EstimateInfoTrigger
            className={spaceAmountFromParent ? 'align-middle' : 'ml-2xs align-middle'}
            id={id}
            onMobileClick={onMobileClick}
        />
    </span>
);
